module.exports = __webpack_public_path__ + "static/img/home-2.438b1aba.png";